<template>
  <div style="height: 100%">
    <widget-wrapper
      :id="configItem.chartId"
      :title="title"
      :subTitle="subTitle"
      :addtxt="chartAttr.addtxt"
      :info="chartAttr.info"
      :empty="empty"
      :loading="loadingbar"
      @ctrl="ctrlClick"
      class="default6"
      @download="downloadChart"
      ref="widgetWrap"
      :isTop5="true"
    >
      <!-- legend 1줄에 18px씩-->
      <div :style="`width: 100%; height: 222px`">
        <div style="position: relative; top: -60px; height: 322px; width: 100%">
          <v-chart
            ref="chart"
            :autoresize="true"
            :option="chartOptions"
            :style="`width: 100%; height: 322px;`"
          />
        </div>
      </div>
      <template v-slot:extra-action></template>
    </widget-wrapper>
    <div v-if="downloadStatus" style="width: 0px; height: 0px; overflow: hidden">
      <widget-wrapper
        :id="configItem.chartId"
        :title="title"
        :subTitle="subTitle"
        :addtxt="chartAttr.addtxt"
        :info="chartAttr.info"
        :empty="empty"
        :loading="loadingbar"
        @ctrl="ctrlClick"
        class="default6"
        ref="chartElement"
        :style="`min-width: ${minWidthChart}px;`"
      >
        <!-- legend 1줄에 18px씩-->
        <v-chart
          :autoresize="true"
          :option="downloadOption"
          :style="`min-width: ${minWidthChart}px; min-height: 322px;`"
          @finished="onFinishRendering"
        />
        <template v-slot:extra-action></template>
      </widget-wrapper>
    </div>
  </div>
</template>
<script>
import _ from 'lodash';
import ECharts from 'vue-echarts';
import 'echarts/lib/chart/bar';
import 'echarts/lib/chart/scatter';
import 'echarts/lib/component/tooltip';
import widgetWrapper from '@/components/scpm/widgets/common/widgetWrapperScpm';
import widgetMixin from './widgetMixin';
import widgetDownloadMixin from './widgetDownloadMixin';
import { getWidgetData } from '../serviceApi';
import '@style/ui/uiDownloadChart.scss';

export default {
  name: 'PerfermanceTop5Widget',
  components: { widgetWrapper, 'v-chart': ECharts },
  mixins: [widgetMixin, widgetDownloadMixin],
  emits: ['popup'],
  computed: {
    empty() {
      return this.$util.isEmpty(this.items.data) || !this.isWidgetAuth;
    },
    // 위젯 타이틀
    title() {
      return this.chartAttr.title;
    },
    subTitle() {
      const productName = this.chartAttr.widget.options.resourceTypeName;
      const performanceItemName = this.chartAttr.widget.options.perfTitle;
      if (this.isCustomDashboard && productName) return `${productName} - ${performanceItemName}`;
      return this.chartAttr.subtitle;
    },
    minWidthChart() {
      return this.maxLabelWidth + Math.max(this.maxLabelWidth, 365);
    }
  },
  data() {
    return {
      items: { data: [] },
      metricUnit: {},
      chartOptions: {},
      downloadOption: {},
      downloadStatus: false,
      maxLabelWidth: 0,
      ignoreCheckAuth: true
    };
  },
  methods: {
    downloadChart() {
      const downloadOption = this.buildOption(true);
      this.downloadOption = {
        ...downloadOption,
        grid: {
          ...downloadOption.grid,
          width: `auto`,
          top: 0,
          bottom: 32,
          right: this.getMaxWidthUnit(this.metricUnit.unit) + 55
        }
      };
      this.downloadStatus = true;
      if (!this.items.data.length) return this.onFinishRendering(this.$refs.widgetWrap.$el);
    },
    onFinishRendering(element) {
      const el = element || this.$refs.chartElement.$el;
      el.classList.add('widget-custom');
      const nameDownload = this.title + `_${this.subTitle}`;
      this.downloadWidget(el, nameDownload);
    },
    hasEmptyConfig(...rest) {
      for (let i in rest) {
        if (this.$util.isEmpty(rest[i])) return true;
      }
      return false;
    },
    // API Call  getData
    async getData() {
      if (
        this.hasEmptyConfig(
          this.configItem.chartAttr.widget.options.resourceType,
          this.configItem.chartAttr.widget.api,
          this.configItem.chartAttr.widget.options.metricKey
        )
      ) {
        return;
      }
      let options = this.configItem.chartAttr.widget.options;
      let body = { objectType: options.objectType };
      let apiPath = '';
      if (options.resourceType == 'VPC' || options.resourceType == 'TGW') {
        body.perfTitle = options.perfTitle;
        apiPath = '/VPC';
      } else {
        body.metricKey = options.metricKey;
      }

      const header = {
        ...this.header,
        'X-ResourceType': options.resourceType
      };
      const data = await getWidgetData(
        'post',
        `${this.configItem.chartAttr.widget.api}${apiPath}`,
        body,
        header
      );
      if (data instanceof Error || !data.contents.length) return;
      const { contents: metricData } = data;
      const { metricUnit, fixedUnit } = metricData[0];
      const units = { usageUnit: fixedUnit ?? metricUnit };
      this.metricUnit.unit = units.usageUnit;
      this.metricUnit.orgUnit = units.usageUnit;
      const isAbleToConvert = this.$util.isUnitAbleToConvert(metricUnit);
      if (!fixedUnit && isAbleToConvert) {
        const listMaxValues = metricData.map((e) =>
          e.perfData.reduce((acc, cur) => Math.max(acc, Number(cur.value)), -Infinity)
        );
        const maxValue = Math.max(...listMaxValues);
        const { unit: highestUnit } = this.$util.convertToHigherUnit(maxValue, metricUnit);
        units.usageUnit = highestUnit;
        this.metricUnit.unit = highestUnit;
      }
      const chartData = [];
      for (const item of metricData) {
        const chartItemName = [
          item.productName,
          item.objectDisplayName ? `.${item.objectDisplayName}` : ''
        ].join('');
        const value = Number(item.perfData[0].value);
        const chartItemValue = isAbleToConvert
          ? this.$util.convertToSpecificUnit(value, metricUnit, units.usageUnit).value
          : value;
        chartData.push([chartItemName, Number(chartItemValue.toFixed(2)), item.productSq]);
      }
      chartData.sort((a, b) => a[1] - b[1]);
      this.items.data = chartData;
      this.$nextTick(function () {
        this.chartOptions = this.buildOption();
        const chartEl = this.$refs.chart && this.$refs.chart.chart;
        if (!chartEl) return;
        chartEl.on('click', ({ componentType, dataIndex }) => {
          if (componentType === 'yAxis') {
            return chartEl.dispatchAction({
              type: 'showTip',
              seriesIndex: 0,
              dataIndex
            });
          }
          this.onClickPopup(this.items.data[dataIndex]);
        });
      });
    },
    getMaxWidthChartLabel(data) {
      let maxWidth = 0;
      const canvas = document.createElement('canvas');
      const context = canvas.getContext('2d');
      context.font = 'normal 16px Noto Sans KR, Arial, sans-serif';
      for (const item of data) {
        const el = context.measureText(item[0]);
        maxWidth = Math.max(maxWidth, el.width);
      }
      return (maxWidth = Math.min(maxWidth, Math.floor(screen.width / 2)));
    },
    getMaxWidthUnit(unit = '') {
      const canvas = document.createElement('canvas');
      const context = canvas.getContext('2d');
      context.font = 'normal 16px Noto Sans KR, Arial, sans-serif';
      const el = context.measureText(`(${unit})`);
      return el.width ?? 0;
    },

    // 차트정보 셋팅
    buildOption(download = false) {
      const data = this.items.data;
      this.maxLabelWidth = this.getMaxWidthChartLabel(data);
      let option = {
        tooltip: {
          trigger: 'item',
          backgroundColor: '#fff',
          borderWidth: 0,
          formatter: (params) => {
            return `<div style="color:#1f2533;display:flex;line-height: 14px;">
                        <div><span style="display:inline-block;margin-right:5px;border-radius:10px;width:9px;height:9px;background-color:${params.color}"></span></div>
                        <div style='font-size:12px; word-break:break-all; white-space:break-spaces; max-width: 230px'>${params.name}</div>
                        <div style="margin-left:10px">${params.value} ${this.metricUnit.unit}</div>
                    </div>`;
          },
          confine: true,
          appendToBody: true
        },
        grid: {
          left: download ? this.maxLabelWidth : '70px',
          right: '55px'
        },

        xAxis: {
          type: 'value',
          name: '(' + this.metricUnit.unit + ')',
          axisLine: {
            show: true,
            lineStyle: {
              color: '#787c84'
            }
          },
          axisLabel: {
            interval: 'auto',
            overflow: 'truncate',
            axisLabel: {
              formatter: _.bind(function (value, index) {
                if (this.metricUnit.unit == this.metricUnit.orgUnit) {
                  return this.$filters.comma(value);
                } else {
                  return this.$filters.comma(value) + this.metricUnit.unit;
                }
              }, this)
            }
          }
        },
        yAxis: {
          data: this.items.data.map((e) => e[0]),
          type: 'category',
          splitLine: {
            show: true
          },
          axisLabel: {
            width: download ? this.maxLabelWidth : 63,
            fontSize: 12,
            overflow: download ? 'breakAll' : 'truncate',
            align: 'left',
            margin: download ? this.maxLabelWidth : 70
          },
          axisTick: { show: false },
          axisPointer: {
            show: false,
            triggerTooltip: true
          },
          triggerEvent: true
        },
        series: [
          {
            data: this.items.data.map((e) => e[1]),
            type: 'bar',
            datasetIndex: 0,
            encode: { x: 'per', y: 'name' },
            barMaxWidth: 14,
            barMinWidth: 14,
            itemStyle: {
              color: '#20bac2',
              opacity: 0.6
            },
            emphasis: {
              itemStyle: {
                color: '#20bac2',
                opacity: 1.0
              }
            },
            cursor: this.isSettingMode ? 'default' : 'pointer'
          }
        ]
      };
      return option;
    },
    // 모니터링 대상 상세 팝업 호출
    onClickPopup(item) {
      if (this.isSettingMode) return;
      let data = {
        id: 'monTargetDetail',
        param: {
          productTypeCode: this.configItem.chartAttr.widget.options.resourceType,
          productId: item[2],
          productName: item[0]
        }
      };
      this.$emit('popup', data);
    }
  }
};
</script>
<style scoped lang="scss">
.widget-chart-bar {
  height: auto;
  margin: 0 auto;
}

.default4 ::v-deep .widget-body {
  padding: 0px 20px;
}

.default4 ::v-deep .echarts {
  height: initial !important;
  min-height: 316px !important;
}

.default4 ::v-deep .chart-tooltip span {
  color: #fff !important;
}
</style>
